<template>
    <table class="table mb-0 table-hover">
        <thead>
        <tr>
            <th></th>
            <th class="cursor-pointer" @click="orderByName">Company&nbsp;&nbsp;<i class="fa fa-sort"></i></th>
            <th>Owner</th>
            <th>Billing Plan</th>
            <th class="cursor-pointer" @click="orderByTrial">Trial Ends&nbsp;&nbsp;<i class="fa fa-sort"></i></th>
            <th colspan="2">Member since</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(team, index) in teams_ordered" :key="team.id + rand">
            <td class="kiosk-company-logo"><img class="spark-profile-photo" :src="team.photo_url"/></td>
            <td><span class="text-muted tw-text-sm">#{{ team.id }}</span>
                {{ team.name }}
                <br>
                <div v-if="team.locations && team.locations.length > 0">
                    <hr>
                    <small class="text-blue cursor-pointer font-weight-bold" @click="showMatchedLocationsForTeamId == team.id ? showMatchedLocationsForTeamId = null : showMatchedLocationsForTeamId = team.id">
                        Matching Locations
                        <i v-if="showMatchedLocationsForTeamId == team.id" class="fa fa-chevron-down"></i>
                        <i v-if="showMatchedLocationsForTeamId != team.id" class="fa fa-chevron-up"></i>
                    </small>
                    <hr>
                    <div v-show="showMatchedLocationsForTeamId == team.id">
                        <ul>
                            <li v-for="(location, index) in team.locations" :key="'location_id' + location.id + rand">
                                <small><i>(id: {{location.id}})</i> &nbsp {{ location.name }}</small>
                            </li>
                        </ul>
                    </div>

                </div>
            </td>
            <td>{{ team.owner ? team.owner.name : 'Owner Not Found' }}</td>
            <td>{{ team.current_billing_plan || trialPlanMessage(team) | capitalize }}</td>
            <td>{{ team.trial_ends_at | date('MMMM Do YYYY') }}</td>
            <td>{{ team.created_at | date('MMMM Do YYYY') }}</td>
            <td>
                <div class="btn-group">
                    <button class="btn btn-outline-primary btn-sm" @click="editCompany(team)"><i
                            class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-outline-primary btn-sm" @click="usersList(team)"><i class="fa fa-users"></i>
                    </button>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            teams: {type: Array, default: null},
        },

        data: () => ({
            order_by_trial: false,
            order_by_name : true,
            teams_ordered : [],
            rand          : Math.random().toString(36),
            showMatchedLocationsForTeamId: null,
        }),

        created() {
            this.teams_ordered = this.teams;
        },

        watch: {
            teams(newValue) {
                this.teams_ordered = newValue;
            }
        },

        methods: {

            editCompany(team) {
                this.$emit('editCompany', team);
            },

            orderByTrial() {
                this.order_by_trial = !this.order_by_trial;
                this.order_by_name  = false;

                if (this.order_by_trial) {
                    this.teams_ordered = _.orderBy(this.teams_ordered, 'trial_ends_at', 'asc')
                    return;
                }
                this.teams_ordered = _.orderBy(this.teams_ordered, 'trial_ends_at', 'desc')

                if (this.order_by_name) {
                    this.teams_ordered = _.orderBy(this.teams_ordered, 'name', 'asc')
                    return;
                }
                this.teams_ordered = _.orderBy(this.teams_ordered, 'name', 'desc')

            },

            orderByName() {
                this.order_by_name  = !this.order_by_name;
                this.order_by_trial = false;

                if (this.order_by_name) {
                    this.teams_ordered = this.teams;
                    return;
                }
                this.teams_ordered = _.orderBy(this.teams_ordered, 'name', 'desc')
            },

            trialPlanMessage(team) {
                return team.is_in_expired_trial
                       ? 'Expired Trial'
                       : 'Trial';
            },

            usersList(team) {
                this.$emit('allUsers', team);
            }
        }
    };
</script>

<style scoped>
    table tbody td {
        vertical-align: middle;
    }

    .kiosk-company-logo {
        padding: 0 !important;
        text-align: center;
        width: 60px;
    }
</style>
